
import { defineComponent, ref, onMounted, PropType, computed } from "vue";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import eventModel from "@/core/models/share/inviteEvent.interface";
import invitePersonModel from "@/core/models/share/invitePerson.interface";
import {
  Module as HosterModule,
  Actions as HosterActions,
  Getters as HosterGetters
} from "@/store/enums/hosterEnums";
import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply
} from "@/store/enums/paramsEnums";
import { useStore } from "vuex";
import {
  Module as ExposedModule,
  Actions as ExposedActions,
  Mutations as ExposedMutations,
  Getters as ExposedGetters
} from "@/store/enums/exposedEnums";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "participantModalFinish",
  components: {},
  props: {
    name: { type: String, default: "response" },
    event: { type: Object as PropType<eventModel | null> }
  },
  setup(props: any, context: any) {
    const store = useStore();
    // const attendee = computed<Array<invitePersonModel>>(
    //   () => store.getters[HosterModule.desc + HosterGetters.InvitePerson]
    // );
    const { t, locale } = useI18n();
    const attendee = computed<Array<invitePersonModel>>(
      () =>
        store.getters[
          ExposedModule.desc + ExposedGetters.MyParticipationEventsResponses
        ]
    );
    function datetimeFormat(dateFrom: string) {
      return dayjs( dateFrom).format("YYYY/MM/DD (ddd) HH:mm ~ ");
    }

    onMounted(() => {});

    return {
      datetimeFormat,
      dayjs,
      attendee,
      ParamEventStatus,
      ParamIsResolution,
      t
    };
  }
});
